import { render } from "./Innovation.vue?vue&type=template&id=4423ea9b"
import script from "./Innovation.vue?vue&type=script&lang=js"
export * from "./Innovation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__